import React, { Fragment } from "react";
import { connect } from "react-redux";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import { addToCart, addToWishList } from "../../../store/actions/action";
import ShopProduct from "../../../components/ShopProduct/lunch";

import api from "../../../api";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import { NavLink } from "react-router-dom";
import Premium from "../../../components/ShopProduct/lunch/Premium";
import Luxury from "../../../components/ShopProduct/lunch/Luxury";

const Lunch = ({ addToCart, addToWishList }) => {
  const productsArray = api();

  const addToCartProduct = (product, qty = 1) => {
    addToCart(product, qty);
  };

  const addToWishListProduct = (product) => {
    addToWishList(product);
  };
  const [lunch, setLunch] = React.useState("standard");

  const products = productsArray;

  return (
    <Fragment>
      <Navbar hclass={"wpo-header-style-3"} />
      {/* <PageTitle pageTitle={"Lunch"} pagesub={"Lunch"} /> */}
      <nav className="toggleNav">
        <ul className="d-flex justify-content-center fs-2 ">
          <li
            className={`p-4 cursor-poinr ${
              lunch == "standard" ? "text-warning" : ""
            }`}
            id="standard"
            onClick={() => setLunch("standard")}
            style={{ cursor: "pointer" }}
          >
            Standard Lunch
          </li>
          <li className="p-4 cursor-pointer">
            <i className="	fa fa-angle-double-right"></i>
          </li>
          <li
            className={`p-4 cursor-pointer ${
              lunch == "premium" ? "text-warning" : ""
            }`}
            id="premium"
            onClick={() => setLunch("premium")}
            style={{ cursor: "pointer" }}
          >
            Premium Lunch
          </li>
          <li className="p-4 cursor-pointer">
            <i className="	fa fa-angle-double-right"></i>
          </li>
          <li
            className={`p-4 cursor-pointer ${
              lunch == "luxury" ? "text-warning" : ""
            }`}
            id="luxury"
            onClick={() => setLunch("luxury")}
            style={{ cursor: "pointer" }}
          >
            Luxury Lunch{" "}
          </li>
        </ul>
      </nav>
      <section className="wpo-shop-page section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {lunch == "standard" && <ShopProduct />}
              {lunch == "premium" && <Premium />}
              {lunch == "luxury" && <Luxury />}
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default connect(null, { addToCart, addToWishList })(Lunch);
